import React from "react";

export default function Flag({ code, squared = false }) {
  const cc = code?.toLowerCase();
  return <span className={`fi ${squared ? "fis" : ""} fi-${cc}`} aria-label={code} />;
}
